import React from "react";
import WhatsApp from "./whatsApp/WhatsApp";
import { Box } from "@mui/material";
import { COLOR_MAP } from "../../constants/ColorNames";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCampaignCreationQueryData } from "../../redux/slice/campaignSlice";

interface IProps {
  campaignType: "whatsApp" | "email";
}

const CampaignCreationV2: React.FC<IProps> = ({ campaignType }) => {
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch()
    React.useEffect(() => {
        const currentParams: Record<string, string> = {};
        searchParams?.forEach((value, key) => {
          currentParams[key] = value;
        });
    
        const formattedQuery = {
          campaignInitiationId: currentParams?.initiationId,
          triggeredFromPage: currentParams?.triggeredFromPage,
          timeZone: currentParams?.timeZone,
          isBulkCampaign: currentParams?.isBulkCampaign,
          searchId: currentParams?.searchId,
          childSearchId: currentParams?.childSearchId
        }
        dispatch(setCampaignCreationQueryData({ campaignCreationQueryData: formattedQuery }))
      }, [dispatch, searchParams])

  if (!campaignType) {
    return null;
  }

  return (
    <Box
      sx={{
        px: 4,
        py: 2,
        backgroundColor: COLOR_MAP.GREY,
        height: "100%",
        width: "100%",
        boxSizing: "border-box",
        minWidth: "903px",
      }}
    >
      {campaignType === "whatsApp" && <WhatsApp />}
    </Box>
  );
};

export default CampaignCreationV2;
